import template from './payment-item.html';
import controller from './payment-item.controller';

let paymentItemComponent = {
    bindings: {
        model: '=',
        editing: '<',
        onRemove: '&',
        onChange: '&'
    },
    template,
    controller
};

export default paymentItemComponent;
